
















































































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CouponMixinV2 from './mixin/mixin-v2.vue';
@Component
export default class Coupon extends mixins(CouponMixinV2) {
  /** 是否是券包 */
  get isPkgCoupon() {
    return !!this.couponInfo.pkgCount;
  }
  /** 是否展示阴影,如果是连锁券 or 券包 or 需要展示阴影，则会展示阴影 */
  get isShowShadow() {
    return this.isChain || this.isPkgCoupon || this.couponInfo.isShowShadow;
  }
  /** 覆盖 mixin --- 是否展示优惠券底部提示条 */
  get isShowTips() {
    const result = this.isExpire ? !this.isExpire : !!this.couponInfo.tipsTextRight;
    return result;
  }
  parseAriaLabel(text: string) {
    return this.parseCurrencyAria(text, true, this.currencyType);
  }
}
